export default __webpack_public_path__ + "static/media/user.0d14c699.png";